/*
 * Copyright (c) 2018 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.crossplatform.client.layer

import js.typedarrays.Uint8ClampedArray
import kotlinx.browser.window
import org.mkui.canvas.AbstractAveragingLayer
import org.mkui.canvas.CanvasRenderingContext2DLayer
import org.mkui.geom.Rectangle
import org.mkui.graphics.IDrawing
import org.w3c.dom.Document
import web.canvas.CanvasRenderingContext2D
import web.canvas.ID
import web.html.HTMLCanvasElement
import web.images.ImageData
import web.rendering.RenderingContext

class ElementalAveragingGWTLayer(iDrawing: IDrawing, antialiasing: Boolean) : AbstractAveragingLayer(), CanvasRenderingContext2DLayer {
    private val iDrawing: IDrawing
    private val antialiasing: Boolean
    private var image: ImageData? = null
    private val canvas: HTMLCanvasElement

    override fun prepare(width: Int, height: Int) {
        if (iDrawing.isActive && width > 0 && height > 0) {
            resize(width, height)
            //        if(visualLayer.getObjectCount() > 0) {
            iDrawing.draw(g, null, width.toDouble(), height.toDouble(), Rectangle(0, 0, width, height))
            val pixelWriter: Uint8ClampedArray<*> = image!!.data
            val pw = pixelWriter
            for (i in 0 until overlay.size) {
                val count: Int = overlay.get(i)
                var s = i * 4
                if (count > 0) {
                    val c: FloatArray = rgb.get(i)
                    val red = c[0] / count
                    val green = c[1] / count
                    val blue = c[2] / count
//                    assert(red >= 0f && red <= 1f) { red.toString() + ", " + c[0] + ", " + count }
//                    assert(green >= 0f && green <= 1f) { green.toString() + ", " + c[1] + ", " + count }
//                    assert(blue >= 0f && blue <= 1f) { blue.toString() + ", " + c[2] + ", " + count }
//                    val color = colorOf(red, green, blue)
//                    val array = arrayOf(color.r.toByte(), color.g.toByte(), color.b.toByte(), color.a.toByte())
//                    pixelWriter.set(array, i * 4)
                    val a = 255
                    pw[s++] = red.toInt().toShort()
                    pw[s++] = green.toInt().toShort()
                    pw[s++] = blue.toInt().toShort()
                    pw[s++] = a.toShort()
                } else {
//                    val array = arrayOf(255.toByte(), 255.toByte(), 255.toByte(), 0.toByte())
//                    pixelWriter.set(array, i * 4)
                    val c = 255.toShort()
                    val a = 0.toShort()
                    pw[s++] = c
                    pw[s++] = c
                    pw[s++] = c
                    pw[s++] = a
                }
            }
            if (antialiasing) {
                image = createAntiAliasedImage(image)
            }
            if (image != null) {
                val context: RenderingContext? = canvas.getContext(CanvasRenderingContext2D.ID)
                val g: CanvasRenderingContext2D = context.unsafeCast<CanvasRenderingContext2D>()
                g.putImageData(image!!, 0, 0)
            }
        }
    }

    fun resize(width: Int, height: Int) {
        if ((this.width != width || this.height != height) && width > 0 && height > 0) {
            canvas.width = width
            canvas.height = height
            val context: RenderingContext? = canvas.getContext(CanvasRenderingContext2D.ID)
            val g: CanvasRenderingContext2D = context.unsafeCast<CanvasRenderingContext2D>()
            val bufferedImage: ImageData = g.createImageData(width, height)
            val o = IntArray(width * height)
            var rgb = Array(width * height) { FloatArray(3) }
            for (i in rgb.indices) {
                rgb[i] = FloatArray(3)
            }
            this.width = width
            this.height = height
            image = bufferedImage
            this.overlay = o
            rgb = rgb
            cx1 = 0
            cy1 = 0
            cx2 = width - 1
            cy2 = height - 1
        } else {
            clear()
        }
    }

    override fun render(g: CanvasRenderingContext2D) {
        if (iDrawing.isActive && image != null) {
            g.drawImage(canvas, 0.0, 0.0)
        }
    }

    private fun createAntiAliasedImage(img: ImageData?): ImageData? {
//        return new AntiAliasingBufferedImageOp().filter(img, null);
        return img
    }

    fun clear() {
        if (image != null) {
            overlay.fill(0)
            for (c in rgb) {
//                        Arrays.fill(c, 0f);
                c[0] = 0f
                c[1] = 0f
                c[2] = 0f
            }
            //            final Graphics2D graphics = (Graphics2D)image.getGraphics();
//            graphics.setComposite(AlphaComposite.Clear);
//    //        graphics.setColor(new Color(255, 255, 255, 0));
//            graphics.fillRect(0, 0, image.getWidth(), image.getHeight());
//            graphics.setComposite(AlphaComposite.SrcOver);
//            graphics.dispose();
        }
    }

    val drawing: IDrawing
        get() = iDrawing

    init {
        this.iDrawing = iDrawing
        this.antialiasing = antialiasing
        val document: Document = window.document
        canvas = document.createElement("canvas") as HTMLCanvasElement
    }
}